import {
  hasFlex,
  hasSolar,
  isOnlySolar,
  isOnlySOL,
  isFlexOnly,
  isContractorTypeEnergy,
} from './account';
import {
  findApprovedMilestoneProgramForProjectType,
  hasApprovedProgramForProjectType,
} from './programs';
import { BorrowerForm } from './ui/borrowerForm';

/**
 * Everything about the installer — account attributes at the top level,
 * UI-specific rules nested under `Installer.UI`. Call sites can also
 * destructure for shorter paths:
 *
 *   const { BorrowerForm } = Installer.UI;
 *   BorrowerForm.projectType(account, assets);
 *
 * Why nested instead of flat: as more installer-related concerns appear
 * (Products, UI variants, etc.) keeping them under a single named
 * import keeps documentation and discovery scoped.
 */
export const Installer = {
  hasFlex,
  hasSolar,
  isOnlySolar,
  isOnlySOL,
  isFlexOnly,
  isContractorTypeEnergy,
  Programs: {
    findApprovedMilestoneProgramForProjectType,
    hasApprovedProgramForProjectType,
  },
  UI: {
    BorrowerForm,
  },
};
